(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["spotify-playlists"] && !Shopify.designMode) return;
  try {
    const initSpotifyPlaylistsBlock = (block) => {
    if (!block) return;

    const items = block.querySelectorAll('[data-playlist]');
    const player = block.querySelector('[data-spotify-player]');

    if (!items.length || !player) return;

    const switchPlaylist = (id) => {
      if (!id) return;
      player.src = `https://open.spotify.com/embed/playlist/${id}?&theme=0`;
    };

    // Load first playlist on init
    const firstItem = items[0];
    if (firstItem) {
      const firstId = firstItem.dataset.playlist;
      if (firstId) {
        switchPlaylist(firstId);
      }
    }

    // Handle playlist switching on click and keyboard
    items.forEach((item) => {
      item.addEventListener('click', () => {
        const id = item.dataset.playlist;
        switchPlaylist(id);
      });

      // Handle Enter and Space key for accessibility
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const id = item.dataset.playlist;
          switchPlaylist(id);
        }
      });
    });
  };

  const spotifyBlocks = document.querySelectorAll('.spotify-playlists[data-block-id]');
  spotifyBlocks.forEach((block) => initSpotifyPlaylistsBlock(block));
  } catch(e) { console.error(e); }
})();

})();
